<template>
    <div class="fixed z-index-modal bottom-0 lg:bottom-auto overflow-hidden duration-500" :class="SideMenuStore.state.subscription.open ? 'sidebar-open' : 'sidebar-close'">
        <div class="bg-black bg-opacity-70 w-screen h-screen fixed top-0 left-0"
             v-if="SideMenuStore.state.subscription.open"
             @click="clickClose()"></div>
        <div class="sub-side w-full bg-a-egg-f5ebdc relative rounded-t-10 lg:rounded-none">
            <div class="text-24 font-bold py-6 text-center text-a-brown-502314">{{ lbl.subscription.buy.subscription_package }}</div>
            <div class="absolute top-6 right-6">
                <img class="cursor-pointer" @click="clickClose()" src="@/assets/icon/ic-close-brown.svg" />
            </div>
            <div v-if="SideMenuStore.state.subscription.open">
                <div class="pb-16">
                    <div class="subscription-list">
                        <SubscirptionItem
                            v-for="(subscriptionitem, index) in subscriptionList"
                            :key="subscriptionitem.Key"
                            :subscriptionitem="subscriptionitem"
                            @onClickSubscription="onClickSubscription(index)"
                            @onClickBuyNow="onClickBuyNow(index)"
                        ></SubscirptionItem>
                    </div>
                    <div class="text-14 text-a-green-198737 text-center pt-4" v-show="isShowPrice">{{ lbl.subscription.buy.saved }} {{calDiscount()}} {{ lbl.subscription.buy.bath }}</div>
                </div>
                <div class="px-4 pb-4 fixed bottom-0 w-full flex lg:absolute">
                    <div class="w-64 mx-auto" >
                        <RedButton @click="clickConfirm()">
                            {{ lbl.subscription.buy.confirm }}
                        </RedButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//helper
//component
// import CartOrderList from '@/module/ShoppingCart/component/CartOrderList.vue';
import RedButton from '../../Button/RedButton.vue';
import SubscirptionItem from '@/module/Subscription/List/component/SubscirptionItem.vue';
import Util from '@/helper/Utility'
//mixin
import DeliveryMixin from '@/mixin/DeliveryMixin.js'
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
export default {
    name: "Subscirption",
    mixins: [DeliveryMixin,ModalMixin,LocaleMixin],
    inject: ['SideMenuStore','CartCountStore','PlaceOrderStore','SubscriptionSelected'],
    components: {
        SubscirptionItem,
        RedButton
    },
    data: function() {
        return {
            pageActive: this.$route.name,
            isLoaded: false,
            isOrderEmpty: false,
            cartItemList: null,

            subscriptionList: [],
            price: 0,

            interval: null,
            isLoadedSaveCart: true,
            isShowPrice: false,
            subscriptionType: 'online',
        };
    },
    watch:{
        $route: function() {
            this.closeMenu();
        },

        'SideMenuStore.state.subscription.open': function () {
            let active = this.SideMenuStore.state.subscription.open;
            console.log('side menu change', this.SideMenuStore.state.subscription.open);
            setTimeout(() => {
                if (active) {
                    this.isLoaded = false;
                    this.isOrderEmpty = false;
                    this.subscriptionList = this.SideMenuStore.methods.getSubscriptionList();
                    this.price = this.SideMenuStore.methods.getPrice();
                    this.subscriptionType = this.SideMenuStore.methods.getType();
                    this.isShowPrice = this.subscriptionType == 'online' ? true : false;
                    document.body.classList.add('not-scroll');

                    console.log('campaignOptions', this.subscriptionList);
                } else {
                    document.body.classList.remove('not-scroll');
                }
            }, 500);
        },
    },
    methods: {
        clickClose: function() {
            if (!this.isLoadedSaveCart) return;
            this.closeMenu();
        },
        closeMenu: function() {
            this.SideMenuStore.methods.closeSubscription();
        },
        onClickSubscription: function(index) {
            this.subscriptionList[index].Selected = !this.subscriptionList[index].Selected;
  
            if (this.subscriptionList[index].Selected) {
                this.subscriptionList.forEach((item, i) => {
                    if (i !== index) {
                        item.Selected = false;
                    }
                });
            }
            let selected = this.subscriptionList.filter((item) => item.Selected);
            // console.log('selected', selected);
            if (selected.length == 0 && this.subscriptionType == 'offline') {
                this.subscriptionList[0].Selected = !this.subscriptionList[0].Selected
            }

            if (selected.length == 0) {
                this.SubscriptionSelected.value = false
            } else {
                this.SubscriptionSelected.value = true
            }
        },

        calDiscount: function() {
            let subscription = null;
            let discount = 0;
            this.subscriptionList.forEach((item) => {
                if (item.Selected) {
                    subscription = item;
                }
            });
           
            if (subscription) {
                if (subscription.DiscountType == "To") {
                    discount = this.price == null ? null : this.price - subscription.Discount; 
                } else if (subscription.DiscountType == "Percent") {
                    discount = parseFloat((this.price * subscription.Discount) / 100).toFixed(1);
                } else if (subscription.DiscountType == "Price") {
                    discount = subscription.Discount;
                }
            }

            return Util.formatNum(Math.floor(discount));
        },

        
        onClickBuyNow: function(index) {
            this.$router.push('/reward/' + this.subscriptionList[index].CampaignId);
            this.closeMenu();
        },
        clickConfirm: function() {
            this.SideMenuStore.methods.sendCallbackSubscription(this.subscriptionList)
            this.closeMenu();
        },
        openMenu: function() {
            this.SideMenuStore.methods.openSubscription();
            
            // this.CartCountStore.methods.updateCartCount();
        },
        onLoadSuccess: function() {
            this.isLoaded = true;
        },
        
    
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .sidebar-open {
        width: 100vw;
        bottom: 0px;
        @include min-desktop {
            right: 0px;
            width: 456px;
            bottom: auto;
        }
    }
    .sidebar-close {
        width: 100vw;
        bottom: -100vh;
        @include min-desktop {
            width: 456px;
            bottom: auto;
            right: -456px;
        }
    }

    .sub-side {
        min-height: calc(100vh / 2);
        @include min-desktop {
            height: 100vh;
        }
    }

    .order-empty-screen {
        height: calc(100vh - 77px);
    }

    .order-list {
        height: calc(100vh - 240px);
        @include min-desktop {
            height: calc(100vh - 180px);
        }
    }

    .subscription-list {
        height: 40vh;
        overflow: scroll;
        @include min-desktop {
            height: calc(100vh - 200px);
        }
    }
</style>
